module.exports = __webpack_public_path__ + "img/brickstreamdevice.d1aad3b9.png";